module.exports = __webpack_public_path__ + "static/media/Shave.7f9dd359.png";